module.exports = __webpack_public_path__ + "static/media/micosmo-icon.06e3433d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/micosmo-icon.png
// module id = 796
// module chunks = 0